import React, { useState, useEffect } from 'react';
import { Card, Col, Container, Row, Table, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import BreadCrumb from 'Common/BreadCrumb';
import Swal from 'sweetalert2'; // Import SweetAlert2
import axios from 'axios'; // Import axios

const Sertifikasi = () => {
  document.title = 'Sertifikasi | CITY SERVICE';

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    parent_id: '',
    category: '',
    required: '',
    type: '',
  }); // Updated form data state
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [tableData, setTableData] = useState<{ id: number; name: string; parent_id: string; category: string; required: string; type: string }[]>([]); // Ensure default value is an empty array
  const [parentOptions, setParentOptions] = useState<{ id: number; name: string }[]>([]); // State for parent options



  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({ name: '', parent_id: '', category: '', required: '', type: '' });
  };

  const handleEdit = (sertifikasi: any) => {
    setEditingId(sertifikasi.id);
    setFormData({
      name: sertifikasi.name,
      parent_id: sertifikasi.parent_id || '',
      category: sertifikasi.category || '',
      required: sertifikasi.required || '',
      type: sertifikasi.type || '',
    });
    setShowModal(true);
  };



  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };



  const handleFormSubmit = async () => {
    setIsLoading(true); // Start loading
    Swal.fire({
      title: editingId ? 'Updating...' : 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const token = localStorage.getItem('authToken'); // Retrieve token from localStorage
      if (!token) {
        throw new Error('Authentication token is missing. Please log in again.');
      }

      const payload = {
        name: formData.name,
        parent_id: formData.parent_id,
        category: formData.category,
        required: formData.required,
        type: formData.type,
      };

      let response;
      if (editingId) {
        // Update existing sertifikasi
        response = await axios.put(
          `/master-sertifikasi/${editingId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to Authorization header
            },
          }
        );
      } else {
        // Create new sertifikasi
        response = await axios.post(
          '/master-sertifikasi',
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to Authorization header
            },
          }
        );
      }

      Swal.fire('Success', `Sertifikasi "${response.data.name}" ${editingId ? 'updated' : 'added'} successfully!`, 'success');
      handleCloseModal();
      fetchSertifikasi(); // Refetch sertifikasi to update the table
    } catch (error) {
      Swal.fire(
        'Error',
        (axios.isAxiosError(error) && error.response?.data?.message) || (error instanceof Error && error.message) || 'An unknown error occurred',
        'error'
      );
    } finally {
      setIsLoading(false); // End loading
    }
  };



  const fetchSertifikasi = async () => {
    setIsLoading(true); // Start loading
    Swal.fire({
      title: 'Loading...',
      html: 'Please wait while we fetch the data.',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const token = localStorage.getItem('authToken'); // Retrieve token from localStorage
      if (!token) {
        throw new Error('Authentication token is missing. Please log in again.');
      }

      const response = await axios.get('/master-sertifikasi', {
        headers: {
          Authorization: `Bearer ${token}`, // Add token to Authorization header
        },
      });

      console.log('API Response Data:', response.data.data); // Debug log
      setTableData(response.data.data || []); // Update table data with API response
      
      // Set parent options from the same data (sertifikasi can be parent of other sertifikasi)
      const parentOpts = response.data.data?.map((item: any) => ({
        id: item.id,
        name: item.name
      })) || [];
      setParentOptions(parentOpts);
      console.log('Parent Options:', parentOpts); // Debug log
      
      Swal.fire({
        icon: 'success',
        title: 'Data Loaded',
        showConfirmButton: false,
        timer: 1000, // Smooth transition after loading
      });
    } catch (error) {
      Swal.fire(
        'Error',
        (axios.isAxiosError(error) && error.response?.data?.message) || (error instanceof Error && error.message) || 'Failed to fetch sertifikasi',
        'error'
      );
    } finally {
      setIsLoading(false); // End loading
    }
  };

  const handleDelete = async (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true); // Start loading
        try {
          const token = localStorage.getItem('authToken'); // Retrieve token from localStorage
          if (!token) {
            throw new Error('Authentication token is missing. Please log in again.');
          }

          await axios.delete(`/master-sertifikasi/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to Authorization header
            },
          });

          Swal.fire('Deleted!', 'The sertifikasi has been deleted.', 'success');
          setTableData((prevData) => prevData.filter((item) => item.id !== id)); // Remove deleted item from table
        } catch (error) {
          Swal.fire(
            'Error',
            (axios.isAxiosError(error) && error.response?.data?.message) || (error instanceof Error && error.message) || 'Failed to delete sertifikasi',
            'error'
          );
        } finally {
          setIsLoading(false); // End loading
        }
      }
    });
  };



  useEffect(() => {
    fetchSertifikasi(); // Fetch sertifikasi on component mount
  }, []); // Fetch sertifikasi on component mount

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb pageTitle="Sertifikasi" title="Sertifikasi" />

          <Row>
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0"></h5>
                    <div className="ms-auto"> {/* Add ms-auto to push the button to the right */}
                      <button
                        className="btn btn-dark d-flex align-items-center gap-1"
                        onClick={handleShowModal}
                      >
                        <i className="ri-add-line"></i>
                        <span>Create</span>
                      </button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Parent Name</th>
                        <th>Category</th>
                        <th>Required</th>
                        <th>Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(tableData) && tableData.length > 0 ? ( // Ensure tableData is an array and not empty
                        tableData.map((sertifikasi, index) => {
                          // Find parent name by matching parent_id with id in the same dataset
                          let parentName = '-';
                          if (sertifikasi.parent_id) {
                            const parent = tableData.find(p => p.id === parseInt(sertifikasi.parent_id));
                            parentName = parent ? parent.name : sertifikasi.parent_id; // fallback to ID if not found
                          }
                          
                          return (
                          <tr key={sertifikasi.id}>
                            <td>{index + 1}</td>
                            <td>{sertifikasi.name}</td>
                            <td>{parentName}</td>
                            <td>{sertifikasi.category || '-'}</td>
                            <td>{sertifikasi.required || '-'}</td>
                            <td>{sertifikasi.type || '-'}</td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle variant="dark" id={`action-dropdown-${sertifikasi.id}`} className="btn-sm">
                                  <i className="ri-more-2-fill"></i> {/* Add an icon for the dropdown toggle */}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item onClick={() => handleEdit(sertifikasi)}>
                                    <i className="ri-edit-line me-2"></i> Edit {/* Add an edit icon */}
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => handleDelete(sertifikasi.id)}>
                                    <i className="ri-delete-bin-line me-2"></i> Delete {/* Add a delete icon */}
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No sertifikasi available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modal for Adding Sertifikasi */}
        <Modal show={showModal} onHide={handleCloseModal} backdrop="static" centered>
          <Modal.Header closeButton>
            <Modal.Title>{editingId ? 'Edit' : 'Add'} Sertifikasi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="name">Name</Form.Label>
                <Form.Control
                  type="text"
                  id="name"
                  placeholder="Enter the name of the certification"
                  value={formData.name}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  isInvalid={!formData.name.trim()} // Validation feedback
                />
                <Form.Control.Feedback type="invalid">
                  Name is required.
                </Form.Control.Feedback>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label htmlFor="parent_id">Parent Sertifikasi</Form.Label>
                <Form.Select
                  id="parent_id"
                  value={formData.parent_id}
                  onChange={handleInputChange}
                  disabled={isLoading}
                >
                  <option value="">Select Parent (Optional)</option>
                  {parentOptions.map((parent) => (
                    <option key={parent.id} value={parent.id}>
                      {parent.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="category">Category</Form.Label>
                    <Form.Control
                      type="text"
                      id="category"
                      placeholder="Enter category (optional)"
                      value={formData.category}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="required">Required</Form.Label>
                    <Form.Control
                      type="text"
                      id="required"
                      placeholder="Enter required info (optional)"
                      value={formData.required}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label htmlFor="type">Type</Form.Label>
                <Form.Control
                  type="text"
                  id="type"
                  placeholder="Enter type (optional)"
                  value={formData.type}
                  onChange={handleInputChange}
                  disabled={isLoading}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal} disabled={isLoading}>
              Close
            </Button>
            <Button variant="dark" onClick={handleFormSubmit} disabled={isLoading}>
              {isLoading ? (editingId ? 'Updating...' : 'Saving...') : (editingId ? 'Update' : 'Save')}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Sertifikasi;
